<template>
    <div class="fst-ds-monitoring">
        <el-form>
            <el-tabs id="dsm-tabs" type="border-card" v-loading="loading">
                <el-tab-pane :label="$t('admin.dsMonitoring.mainTab')" key="main">
                    <h4>{{$t('admin.dsMonitoring.section.dataCoverageSettings')}}</h4>
                    <DataCoverageSettings/>
                    <el-divider/>
                    <h4>{{$t('admin.dsMonitoring.section.newsHostingExport')}}</h4>
                    <NewsHostingExportForm/>
                </el-tab-pane>

                <el-tab-pane v-for="report in reports" :label="report.subsystemName" :key="report.subsystemName">
                    <el-form inline>
                        <el-form-item :label="$t('admin.dsMonitoring.reportTime')">{{ report.reportTime }}</el-form-item>
                        <el-form-item :label="$t('admin.dsMonitoring.received')">{{ report.received }}</el-form-item>
                        <el-button type="primary" plain @click="load"><i class="far fa-sync-alt"></i></el-button>
                    </el-form>
                    <el-divider>{{$t('admin.dsMonitoring.json')}}</el-divider>
                    <el-form-item>
                        <JsonViewer :value="report.reportData" preview-enabled :open="3"/>
                    </el-form-item>
                </el-tab-pane>
            </el-tabs>
        </el-form>
    </div>
</template>

<script>
    import moment from 'moment';
    import JsonViewer from "@/commons/components/JsonViewer.vue";
    import DataCoverageSettings from "@/components/admin/settings/DataCoverageSettings.vue";
    import NewsHostingExportForm from "@/components/admin/settings/NewsHostingExport.vue";

    export default {
        name: "DSMonitoring",
        components: {NewsHostingExportForm, DataCoverageSettings, JsonViewer},
        data() {
            return {
                loading: false,
                reports: []
            };
        },

        mounted() {
            this.load();
        },

        methods: {
            load() {
                this.loading = true;
                this.$services.ds_monitoring.latestReports().prepare({target: this.$el})
                    .then(resp => {
                        setTimeout(() => this.loading = false, 250);
                        this.reports = resp.data.map(r => ({
                            ...r,
                            reportTime: moment(r.reportTime).format('DD MMM YYYY HH:mm:ss'),
                            received: moment(r.received).format('DD MMM YYYY HH:mm:ss')
                        }));
                    })
                    .catch(() => {
                        this.loading = false
                    });
            }
        }
    }
</script>

<style lang="scss">
.fst-ds-monitoring {
    #dsm-tabs { // for specificity
        .el-tabs__content {
            background-color: $iq-color-white;
        }
    }
}
</style>